import { appUrl } from '../../config/appBase';

/**
 * redirect_uri for the Google and LinkedIn authorisation round trip.
 *
 * The callback routes live inside the app, so under ivoriai.com/edu the URI is
 * https://ivoriai.com/edu/auth/google/callback. Authorise (Login, CertPortal)
 * and exchange (the callback pages) must send the exact same string, so both
 * ends call this. pathbuddy.com keeps https://pathbuddy.com/auth/... (no
 * prefix) and localhost:3000/edu gives http://localhost:3000/edu/auth/...
 *
 * Each URI must be registered in the Google Cloud OAuth client and the
 * LinkedIn app, for ivoriai.com and www.ivoriai.com, before deploy.
 */
export const OAUTH_CALLBACK_PATHS = {
  google: '/auth/google/callback',
  linkedin: '/auth/linkedin/callback',
};

export function oauthRedirectUri(provider) {
  const path = OAUTH_CALLBACK_PATHS[provider];
  if (!path) {
    throw new Error(`Unknown OAuth provider: ${provider}`);
  }
  return appUrl(path);
}
